import { DOCUMENT, isPlatformServer } from "@angular/common";
import { Inject, Injectable, PLATFORM_ID, REQUEST } from "@angular/core";
import { Meta } from "@angular/platform-browser";

@Injectable({ providedIn: "root" })
/**
 * Servicio para gestionar la etiqueta `<meta name="canonical">`.
 * Permite establecer o actualizar la URL canónica de una página.
 */
export class CanonicalService {
  constructor(
    @Inject(PLATFORM_ID) private readonly platformId,
    @Inject(REQUEST) private readonly request: Request,
    private readonly meta: Meta,
    @Inject(DOCUMENT) private readonly document: any,
  ) {}

  /**
   * Crea o actualiza <meta name="canonical" content="...">
   */
  setCanonicalUrl() {
    if (isPlatformServer(this.platformId)) {
      const host = this.document?.location?.host;
      const pathname = this.document?.location?.pathname;
      const url = `https://${host}${pathname}`; // <-- fuerza HTTPS
      const link: HTMLLinkElement = this.request?.["document"]?.createElement("link");
      link?.setAttribute("rel", "canonical");
      link?.setAttribute("href", url);
      this.request?.["document"]?.head?.appendChild(link);
    }
  }
}
